import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useAppCustom from '@hooks/useAppCustom';
import { StampCardRow } from '@models/stamp';
import dayjs from 'dayjs';
import { useState } from 'react';

import styles from './styles.module.scss';
import Side from '../Side';

interface Props {
    stampCard: StampCardRow;
    expand: boolean;
}

function FullCard({
  stampCard, expand,
}:Props) {
  const {
    shopName, stampExpiredDays, stampCount, totalSlots,
  } = stampCard;
  const [expireIndex, setExpireIndex] = useState<number>(-1);
  const { stampImage, stampDefaultImage } = useAppCustom().membership;
  console.log(stampExpiredDays);
  return (
        <div className={`${styles.wrapper} ${expand ? '' : styles.hide}`}>
            <div className={styles.contents} >
                <Row className={styles.top}>
                    <div className={styles.bar1} />
                    <Side className={styles.side1}/>
                    <Text className={styles.shopName}>{shopName}</Text>
                </Row>
                <div className={styles.stampContainer}>
                    {Array.from({ length: totalSlots }).map((_, value) => {
                      const stampIcon = (() => {
                        const active = value < stampCount;
                        if (active) {
                          if (stampImage) {
                            return (
                                    <Image width={38}
                                           height={38}
                                           className={styles.image}
                                           src={stampImage}/>
                            );
                          }
                          return (<div className={`${styles.stamp} ${styles.checked}`}/>);
                        }
                        if (stampDefaultImage) {
                          return (
                                <Image width={38}
                                       height={38}
                                       className={styles.image}
                                       src={stampDefaultImage}/>
                          );
                        }
                        return <div className={styles.stamp} />;
                      })();
                      const dateStr = stampExpiredDays?.[value];
                      const leftDays = dateStr ? dayjs(dateStr)
                        .diff(dayjs().set('hour', 0).set('minute', 0).set('second', 0), 'days') + 1 : undefined;
                      return (
                            <Column key={value.toString()}
                                    className={styles.stampWrapper}
                                    align='center'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setExpireIndex(value);
                                    }} >
                                {stampIcon}
                                {(expireIndex === value && value < stampCount) && (
                                    <div className={styles.expires}>
                                        <Text size='s'
                                              fontWeight='bold'
                                              color={colors.white}>
                                            {leftDays}일
                                        </Text>
                                    </div>
                                )}
                            </Column>
                      );
                    })}
                </div>
                <Row fullWidth justify='flex-end' className={styles.bottom}>
                    <Side className={styles.side2}/>
                    <div className={styles.bar2}/>
                </Row>
                 <div className={styles.overlay} />
            </div>
        </div>
  );
}

export default FullCard;
